import { render, staticRenderFns } from "./LffServices.vue?vue&type=template&id=1930d09c&scoped=true&"
import script from "./LffServices.vue?vue&type=script&lang=js&"
export * from "./LffServices.vue?vue&type=script&lang=js&"
import style0 from "./LffServices.vue?vue&type=style&index=0&id=1930d09c&prod&lang=scss&"
import style1 from "./LffServices.vue?vue&type=style&index=1&id=1930d09c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1930d09c",
  null
  
)

export default component.exports